(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.controller('HeaderCtrl', function($rootScope, $location, $scope, $window, vv, vvBrowser, vvConnect, gettextCatalog,
    $filter, vvPopup, vvSupportRegion, vvLocalStorage) {
      $scope.showRegionInfo = true;
      var region = vv.getVvMetaData('region');
      if (region == 'cn'){
        $scope.showBurakLike = vvBrowser.isQQBuiltIn();
        $scope.showQzoneLike = vvBrowser.isQZoneBuiltIn();
        $scope.showWechatLike = vvBrowser.isWeChatBuiltIn();
        $scope.showRegionInfo = false;
        var hostname = window.location.hostname;
        var snsList = vvLocalStorage.get('snsList') || {};
        var candidateList = ['facebook', 'twitter', 'line'];
        for (var i in candidateList) {
          var candidate = candidateList[i];
          if (snsList[candidate] == 'Y') {
            $scope.showRegionInfo = true;
          }
        }
      }

      $scope.showMeLayer = false;
      $scope.goProfile = function($event) {
        $scope.toggleMeLayer($event);
      };

      $scope.toggleMeLayer = function($event) {
        $scope.showMeLayer = !$scope.showMeLayer;
        if ($scope.showMeLayer) {
          var template = '<div class="layer" ng-if="showLayer" ng-click="close($event)"></div>';
          vvPopup.open(template, { showLayer: $scope.showMeLayer, close: $scope.closeMeLayer });
        }
      };

      $scope.closeMeLayer = function() {
        $scope.showMeLayer = false;
        vvPopup.close();
      };

      if (!$window.navigator.cookieEnabled) {
        var getCookieUrl = function() {
          if (vvBrowser.isMobile() && vvBrowser.isChrome()) {
            var lang = vv.getVvMetaData('lang');
            return 'https://support.google.com/chrome/answer/2392971?hl=' + lang;
          }

          return null;
        };

        var cookieError = {
          fatal: false,
          title: gettextCatalog.getString('쿠키 사용 오류'),
          description: gettextCatalog.getString('쿠키가 허용되지 않으면 로그인 등 일부 기능이 동작하지 않을 수 있습니다.')
        };

        var url = getCookieUrl();
        if (url == null) {
          cookieError.closeText = gettextCatalog.getString('닫기');
        } else {
          cookieError.actionText = gettextCatalog.getString('쿠키 허용 방법');
          cookieError.action = function() {
            $window.location.href = url;
          }
        }

        $scope.cookieError = cookieError;
      } else {
        $scope.cookieError = null;
      }

      $scope.loginAvailable = vvConnect.loginAvailable;

      $scope.openCnLayer = function() {
        return vvPopup.openUrl('/m/cnAccountLayer.html?_hv=d1a4018');
      };
    });
  })(window, window.angular);
